// extracted by mini-css-extract-plugin
export default {"truncatedText":"truncated-text_truncatedText__R8oqr","tooltipContent":"truncated-text_tooltipContent__tzP80"};